import API from '@/apis'
import {getQuery, isNotEmpty} from "./utils";
let resizingColumn = null;
let startX = null;
let startWidth = null;
let trEle = null;

let columnsArr = null;
let callBackFun = null;
function tableColResize(event,props,columns,callBack){
    callBackFun = callBack;
    resizingColumn = props.col;
    startX = event.pageX;
    startWidth = event.srcElement.offsetParent.offsetWidth;
    trEle = event.srcElement.offsetParent;
    columnsArr = columns;
    document.addEventListener('mousemove', doResize);
    document.addEventListener('mouseup', stopResize);
}
function doResize(event){
    if (resizingColumn) {
        let newWidth = startWidth + (event.pageX - startX);
        let width = Math.max(10, newWidth)+'px';
        trEle.style.minWidth = width;
        trEle.style.width = width;
        trEle.style.maxWidth = width;
        let findCol = columnsArr.find(item=>{return item.field == resizingColumn.field});
        findCol.style = 'min-width:'+width+';'+'max-width:'+width+';'+'width:'+width+';'
        resizingColumn.style=('min-width:'+width);
    }
}
function stopResize(){
    callBackFun(columnsArr);
    resizingColumn = null;
    startX = null;
    startWidth = null;
    trEle = null;
    columnsArr = null;
    callBackFun = null;
    document.removeEventListener('mousemove', doResize);
    document.removeEventListener('mouseup', stopResize);
}
function getMyColums({name,socketColums}) {
    return new Promise((resolve, reject)=>{
        let userBase = JSON.parse(localStorage.getItem('userBase'));
        let params = {
            name:name,
            user:userBase.id
        }
        let str = getQuery(params)
        API.getUserPreferenceCol(str).then((res)=>{
            if(isNotEmpty(res.data.results)){
                localStorage.setItem(name+'-'+userBase.id,JSON.stringify(res.data.results[0]));
                return resolve(JSON.parse(res.data.results[0].data));
            }else{
                localStorage.removeItem(name+'-'+userBase.id);
                return resolve([]);
            }
        }).catch((error)=>{
            console.log(error,'error');
            return reject();
        })
    })
}
function saveMyColums({name,id,colums}) {
    return new Promise((resolve, reject)=>{
        let userBase = JSON.parse(localStorage.getItem('userBase'));
        let params = {
            params:{
                name:name,
                user:userBase.id,
                data:JSON.stringify(colums)
            }
        }
        if(isNotEmpty(id)){
            params.id = id
        }
        API.setUserPreferenceCol(params).then((res)=>{
            let params = {
                id:res.data.id,
                data:res.data.data
            }
            localStorage.setItem(name+'-'+userBase.id,JSON.stringify(params));
            return resolve();
        }).catch((error)=>{
            return reject();
        })
    })
}
function removePageCols({name}){
    localStorage.removeItem('USER_PREFERENCE_'+name);
}

let cacheSize = parseInt(localStorage.getItem('pageSize'));
let tableSet={
    loading:false,
    isFullscreen:false,
    selected: [],
    selection: 'single',
    rowkey:'id',
    showSelection:true,
    data: [],
    count: 0,
    pagination: { rowsPerPage: cacheSize?cacheSize:30, rowsNumber: 3, page: 1},
    tools: {
        show_toolbar: true,
        btns: []
    },
    tableName:'',
    columns: []
}
    /**
     * 处理表格数据
     * @param pageData 页面的配置数据
     * @param tableName
     * @returns {{pageConfig: {}, allArrData: *[]}}
     * 1.先将第二层放到第一层数据下面
     * 2.处理树形数据
     */
function setPageConfig({pageData,tableName='',top_tools={},isFalsePagination=[],pageUrl=''}){
        let obj2={};
        Object.keys(pageData).forEach((key,idnex)=>{
            if(isNotEmpty(pageData[key]['p_'])){
                obj2[key] = pageData[key];
                delete pageData[key];
            }
        });
        if(isNotEmpty(obj2)){
            Object.keys(obj2).forEach((key,idnex)=>{
                if(!isNotEmpty(pageData[obj2[key]['p_'][Object.keys(obj2[key]['p_'])[0]]].child)){
                    pageData[obj2[key]['p_'][Object.keys(obj2[key]['p_'])[0]]].child = {};
                }
                pageData[obj2[key]['p_'][Object.keys(obj2[key]['p_'])[0]]].child[key] = obj2[key]
            });
        }
        let allArrData = [];
        let pageConfig = {};
        setPageConfigDeep({pageData, allArrData,pageConfig,tableName,top_tools,isFalsePagination,treeIndex:1,pageUrl});
        return {
        allArrData,
        pageConfig
    };
}

/**
 *
 * @param fTabName 父级的tabname,从第三层开始的tabName = fTabName+'.child.'+key
 * @param pageData 对象 接口返回来的所有配置
 * @param allArrData 生成树形结构的数据并抛出，tab页签时会使用
 * @param fdata 父级数据
 * @param pageConfig 页面表格的回显配置数据
 * @param tableName 表格name,用户偏好列的时候会用到，存储数据时冲突
 * @param top_tools 指定某一个表格上面的操作按钮
 * @param isFalsePagination 是否是一个假分页
 * @param treeIndex 当前的树形层级
 * @param pageUrl 页面路由 （发货通知数据结构与其它形式不同，需在2层开始时进行拼接child）
 */
function setPageConfigDeep({fTabName,pageData, allArrData, fdata = null,pageConfig,tableName='',top_tools={},isFalsePagination,treeIndex,pageUrl=''}){
    Object.keys(pageData).forEach((key)=>{
        let keyValue = key;//页签名称
        if(isNotEmpty(pageUrl) && pageUrl == 'shipping-notice' && treeIndex > 1){//发货通知特殊处理
            keyValue = fTabName+'.child.'+key;
        }else if(treeIndex > 2){
            keyValue = fTabName+'.child.'+key;
        }
        pageConfig[keyValue]=JSON.parse(JSON.stringify(tableSet));
        pageConfig[keyValue].tableName = (tableName+'-'+keyValue);
        pageConfig[keyValue].tabName = keyValue;
        pageConfig[keyValue]['p_'] = pageData[key]['p_'];
        pageConfig[keyValue].oldKey = key;
        if(isNotEmpty(pageData[key]['row_key'])){
            pageConfig[keyValue]['rowkey'] = pageData[key]['row_key'];
        }
        if(!isNotEmpty(pageData[key].child)){
            pageConfig[keyValue].selection = 'multiple';
        }
        if(isNotEmpty(top_tools[key])){
            pageConfig[keyValue].tools.btns = top_tools[key];
        }
        if(isNotEmpty(isFalsePagination)&&isFalsePagination.includes(key)){
            pageConfig[keyValue].falsePagination = true;
        }
        pageData[key].tabName =  keyValue;
        pageData[key].oldKey =  key;
        if(isNotEmpty(pageData[key].columns)){//生成列数据
            let columns = [];
            Object.keys(pageData[key].columns).forEach((colKey,index)=>{
                let colData = {
                    name: colKey,field: colKey,check:true, align: 'left',width:'min-width:120px;max-width:120px;width:120px', label: pageData[key].columns[colKey], sortable: true,format: (val) => `${val ? val : ''}`
                }
                if(isNotEmpty(pageData[key]['right_align']) && pageData[key]['right_align'].includes(colKey)){
                    colData.align = 'right';
                }
                columns.push(colData);
            });
            pageConfig[keyValue].columns = columns;
            pageData[key].columns = columns;
        }
        if(isNotEmpty(pageData[key].child)){//生成子集数据
            pageData[key].childrens = [];
            setPageConfigDeep({
                pageData:pageData[key].child,
                allArrData:pageData[key].childrens,
                fdata:pageData[key],
                pageConfig:pageConfig,
                tableName:tableName,
                top_tools:top_tools,
                isFalsePagination:isFalsePagination,
                treeIndex:(treeIndex+1),
                fTabName:pageData[key].tabName,
                pageUrl:pageUrl
            });
        }
        allArrData.push(pageData[key]);
    });
    if(isNotEmpty(fdata)){
        delete fdata.child;
    }
}

/**
 * 页面配置列数据 + 用户偏好 生成 页面
 *   交集+页面配置不交集的部分
 * @param pageConfig
 * @param myColums
 */
function setNowTabPageCongfig({pageConfig,myColums}){
    if(!isNotEmpty(pageConfig) || !isNotEmpty(myColums)){
        return
    }
    let configFileds = pageConfig.columns.map(item=>item.field);
    let lastData = [];
    myColums.forEach(item=>{
        if(configFileds.includes(item.field)){
            lastData.push(item);
        }
    });
    let myColumsFiles = lastData.map(item=>item.field);
    pageConfig.columns.forEach(item=>{
        if(!myColumsFiles.includes(item.field)){
            lastData.push(item);
        }
    });
    pageConfig.columns = lastData;
}

/**
 * 清空数据 当前页签和当前页签下的子页签
 * @param tabName
 * @param pageConfig
 * @param pageConfigTree
 * @param isClearAll
 */
function clearRowDataDeep({tabName,pageConfig,pageConfigTree,isClearAll = false}){
    pageConfigTree.forEach(item=>{
        if(isClearAll || item.tabName == tabName){
            pageConfig[item.tabName].pagination.page = 1;
            pageConfig[item.tabName].selected = [];
            pageConfig[item.tabName].data = [];
        }
        if(isNotEmpty(item.childrens)){
            if(item.tabName == tabName){
                clearRowDataDeep({tabName,pageConfig,pageConfigTree:item.childrens,isClearAll:true})
            }else{
                clearRowDataDeep({tabName,pageConfig,pageConfigTree:item.childrens,isClearAll})
            }
        }
    })
}
export {
    tableColResize,
    getMyColums,
    saveMyColums,
    removePageCols,
    setPageConfig,
    setNowTabPageCongfig,
    clearRowDataDeep
}
